import React from 'react';
import PropTypes from 'prop-types';
import { CollapsibleItemStyle } from '../../css/style';

const styles = CollapsibleItemStyle();

class CollapsibleItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleToggle = (itemId) => {
    this.props.updateParentIsOpen(!this.props.isOpen, itemId);
  }

  handleRender(isOpen, expanded, collapsed, isLocationAdmin) {
    if (isLocationAdmin) return;
    return isOpen ? expanded : collapsed;
  }

  render() {
    const {
      expandedView, collapsedView, item, onClickDeleteIcon, isLocationAdmin,
    } = this.props;
    const isOpen = this.props.isOpen;
    const toggle = () => this.handleToggle(item.id);
    const deleteIcon = (
      <svg onClick={() => onClickDeleteIcon(item)} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    );
    const collapseIcon = (
      <svg onClick={toggle} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z" />
      </svg>
    );
    const expandIcon = (
      <svg onClick={toggle} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" />
      </svg>
    );
    return (
      <div style={styles.collapseContainer}>
        <div style={styles.collapsedView}>
          {collapsedView}
          <div style={styles.expandIconContainer}>
            {!isLocationAdmin && deleteIcon}
            {this.handleRender(isOpen, collapseIcon, expandIcon, isLocationAdmin)}
          </div>
        </div>
        {isOpen && expandedView}
      </div>
    );
  }
}

CollapsibleItem.propTypes = {
  expandedView: PropTypes.objectOf(PropTypes.any).isRequired,
  collapsedView: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default CollapsibleItem;
